var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 1C3.5 0.447812 3.94688 0 4.5 0C5.05312 0 5.5 0.447812 5.5 1V2H9.5V1C9.5 0.447812 9.94687 0 10.5 0C11.0531 0 11.5 0.447812 11.5 1V2H13C13.8281 2 14.5 2.67156 14.5 3.5V5H0.5V3.5C0.5 2.67156 1.17156 2 2 2H3.5V1ZM14.5 14.5C14.5 15.3281 13.8281 16 13 16H2C1.17156 16 0.5 15.3281 0.5 14.5V6H14.5V14.5Z",
    fill: "#8B98AD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarNew);
export default __webpack_public_path__ + "static/media/calendar-new.df87f7cb8bd53433bb3f9f7e25cbc4a0.svg";
export { ForwardRef as ReactComponent };